import { useEffect, useState } from "react";
import jwt_decode from "jwt-decode";
import { useRouteMatch, useHistory, Link } from "react-router-dom";
import routes from "../../util/routes";
import "./BottomNavigation.css";

const BottomNavigation = ({ onSet }) => {
  const [screens, setScreens] = useState([]);
  let { url } = useRouteMatch();
  const history = useHistory();

  useEffect(() => {
    const token = localStorage.getItem("token");
    const decoded = jwt_decode(token);
    // const decoded = {roles: ["admin", "manager", "user"]};
    const updatedScreens = [routes.profile];
    for (let i = 0; i < decoded.roles.length; i++) {
      switch (decoded.roles[i]) {
        case "admin":
          updatedScreens.push(routes.admin);
          break;
        case "manager":
          updatedScreens.push(routes.manager);
          break;
        case "user":
          updatedScreens.push(routes.lessons);
          updatedScreens.push(routes.students);
          break;
        default:
      }
    }
    const sortedScreens = updatedScreens.sort((screenA, screenB) => {
      return screenA.displayIndex > screenB.displayIndex ? 1 : -1;
    });
    setScreens(sortedScreens);
    onSet(sortedScreens[0].path);
    //history.push(`/${url}/${sortedScreens[0].path}`);
  }, []);

  const logout = () => {
    localStorage.clear();
    history.replace("/login");
  };

  return (
    <div className="footer" id="bottomNavigation">
      <ul id="navList">
        {screens.map((screen, index) => {
          return (
            <li key={index}>
              {screen.path === "logout" ? (
                <Link
                  to="#"
                  className="navItem"
                  onClick={() => {
                    logout();
                  }}
                >
                  <img src={screen.icon} alt="" />
                  <span>{screen.label}</span>
                </Link>
              ) : (
                <Link className="navItem" to={`${url}/${screen.path}`}>
                  <img src={screen.icon} alt="" />
                  <span>{screen.label}</span>
                </Link>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default BottomNavigation;
